// src/index.js
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ClerkProvider } from '@clerk/clerk-react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SubscriptionProvider } from './hooks/useSubscription.js';
import { ApiProvider } from './providers/ApiProvider';
import './index.css';

const SENTRY_ENABLED = process.env.NODE_ENV === 'production';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  enabled: SENTRY_ENABLED,
});

// Session Replay (rrweb) is the single heaviest thing in the main bundle and irrelevant
// to first paint, so it is pulled in after the page has loaded instead of shipped inline.
if (SENTRY_ENABLED) {
  const loadReplay = () => {
    Sentry.lazyLoadIntegration('replayIntegration')
      .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
      .catch(() => {});
  };
  if (document.readyState === 'complete') loadReplay();
  else window.addEventListener('load', loadReplay, { once: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      appearance={{
        baseTheme: null,
        variables: {
          borderRadius: '0.5rem',
          colorPrimary: '#3b82f6',
          colorBackground: '#ffffff',
          fontFamily: 'inherit',
        },
        layout: {
          shimmer: false,
          showOptionalFields: false,
          socialButtonsPlacement: "top",
          helpPageUrl: null,
          logoPlacement: null,
          logoImageUrl: null,
          privacyPageUrl: null,
          termsPageUrl: null
        }
      }}
    >
      <BrowserRouter>
        <SubscriptionProvider>
          <ApiProvider>
            <App />
          </ApiProvider>
        </SubscriptionProvider>
      </BrowserRouter>
    </ClerkProvider>
    </HelmetProvider>
  </React.StrictMode>
);